import { useState } from 'react';
import { Row, Col, Typography } from 'antd';
import Data from '../../../CustomText/data';
import { convertCentsIntoDollar, formatDate } from '../../../../helpers/genericHelper';
import { UpOutlined, DownOutlined, DownloadOutlined, LoadingOutlined } from '@ant-design/icons';
import API from '../../../../services/API';

const { Text, Title } = Typography;
export default function StatementView({ statement }) {

  const [expandInfo, setExpandInfo] = useState(false);
  const [loading, setLoading] = useState(false);

  const downloadStatement = async () => {
    setLoading(true);
    try {
      const statementBlob = await API.getProductStatementFile({ type: 'loan', statementId: statement?.statementId });
      var file = new Blob([statementBlob], {type: 'application/pdf'});
      const url = window.URL.createObjectURL(file);
      window.open(url)
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }

  return <>
  <Row>
    <Col span="3">
      <Data title="Statement Date">
        <Title level={5}>{(statement?.statementData?.statementDate)}</Title>
      </Data>
    </Col>
    <Col span="3">
      <Data title="Payment Due Date">
        <Title level={5}>{(statement?.statementData?.dueDate)}</Title>
      </Data>
    </Col>
    <Col span="3">
      <Data title="Previous Balance">
        <Title level={5}>{convertCentsIntoDollar(statement?.statementData?.previousBalance)}</Title>
      </Data>
    </Col>
    <Col span="3">
      <Data title="Payments & Credits" >
        <Title level={5}>{convertCentsIntoDollar(statement?.paymentsAmount)}</Title>
      </Data>
    </Col>
    <Col span="3">
      <Data title="Prinicipal & Fees" >
        <Title level={5}>{convertCentsIntoDollar(statement?.principalAndFeesAmount)}</Title>
      </Data>
    </Col>
    <Col span="3" >
      <Data title="Statement Balance">
        <Title level={3}>{convertCentsIntoDollar(statement?.statementData?.currentBalance)}</Title>
      </Data>
    </Col>
    <Col span="3">
      <Data title="Amount Past Due">
        <Title level={3}>{convertCentsIntoDollar(statement?.amountPastDue)} </Title>
      </Data>
    </Col>
    <Col span="3">
      <Data title="Principal Balance" >
        <Title level={5}>{convertCentsIntoDollar(statement?.statementData?.principalBalance)}</Title>
      </Data>
    </Col>
  </Row>
  <Row>&nbsp;</Row>
  { expandInfo && <>
  <Row>
    <Col span="4">
      <Data title="Last Payment Date">
        <Title level={5}>{(statement?.lastPaymentDate)} </Title>
      </Data>
    </Col>
    <Col span="4">
      <Data title="Statement ID" value={statement?.statementId} copyable/>
      { !loading && <DownloadOutlined onClick={downloadStatement} /> }
      { loading && <LoadingOutlined /> }
    </Col>
    <Col span="15" offset={1} >
        <Title level={5} underline>Items</Title>
        {
          statement?.statementItems && statement?.statementItems.sort((a, b) => new Date(b.transactionInstant) - new Date(a.transactionInstant)).map((payment, index) => (
            <Row key={index}>
              <Col span="6">
                <Data title="Date">
                  {formatDate(payment?.transactionInstant)}
                </Data>
              </Col>
              <Col span="6">
                <Data title="Description">
                  {payment?.type}
                </Data>
              </Col>
              <Col span="4">
                <Data title="Amount">
                  {convertCentsIntoDollar(payment?.amount)}
                </Data>
              </Col>
            </Row>
          ))
        }
        { statement?.statementItems && statement?.statementItems.length === 0 && <Text strong>- No Items -</Text> }
    </Col>
  </Row>
  <Row>&nbsp;</Row>
  </> }
  <Row>
    <Col span={2} offset={10}>
      <Text underline onClick={()=> setExpandInfo(!expandInfo) }>
        {expandInfo ? <UpOutlined /> : <DownOutlined />}
        {expandInfo ? ' Collapse Details' : ' Expand Details'}
        {expandInfo ? <UpOutlined /> : <DownOutlined />}
      </Text>
    </Col>
    <Col span="4" offset="8">
    { statement?.isOverdue && <Data isTag tagColor="error" value="Overdue"/> }
    { statement?.overdueMoreThan30Days && <Data isTag tagColor="error" value="Overdue More Than 30 Days"/> }
    </Col>
  </Row>
</>
}